/* =================== QUERO SER VOLUNTÁRIO — Estado/Cidade + Form Submit =================== */
document.addEventListener("DOMContentLoaded", function () {
  var form = document.getElementById("form-voluntario");
  if (!form) return;

  var estadoSelect = document.getElementById("voluntario-estado");
  var cidadeContainer = document.getElementById("cidade-field-container");
  var btnSubmit = document.getElementById("btn-submit");

  if (estadoSelect && cidadeContainer) {
    estadoSelect.addEventListener("change", function () {
      var uf = this.value;

      if (!uf) {
        cidadeContainer.innerHTML =
          '<label for="voluntario-cidade">Cidade</label>' +
          '<select name="cidade" id="voluntario-cidade" class="campo" required disabled>' +
          '<option value="">Selecione o Estado primeiro</option>' +
          '</select>' +
          '<span class="arrow"></span>';
        return;
      }

      if (uf === "EX") {
        cidadeContainer.innerHTML =
          '<label for="voluntario-cidade">Cidade / País</label>' +
          '<input type="text" name="cidade" id="voluntario-cidade" class="campo" placeholder="Digite sua cidade e país" required />';
        return;
      }

      cidadeContainer.innerHTML =
        '<label for="voluntario-cidade">Cidade</label>' +
        '<select name="cidade" id="voluntario-cidade" class="campo" required disabled>' +
        '<option value="">Carregando cidades...</option>' +
        '</select>' +
        '<span class="arrow"></span>';

      fetch("https://servicodados.ibge.gov.br/api/v1/localidades/estados/" + uf + "/municipios?ordenar=nome")
        .then(function (res) {
          if (!res.ok) throw new Error("Erro na rede");
          return res.json();
        })
        .then(function (data) {
          var options = '<option value="">Selecione a Cidade</option>';
          data.forEach(function (city) {
            options += '<option value="' + city.nome + '">' + city.nome + '</option>';
          });

          cidadeContainer.innerHTML =
            '<label for="voluntario-cidade">Cidade</label>' +
            '<select name="cidade" id="voluntario-cidade" class="campo" required>' +
            options +
            '</select>' +
            '<span class="arrow"></span>';
        })
        .catch(function (err) {
          console.warn("API IBGE indisponível. Mudando para campo de texto.", err);
          cidadeContainer.innerHTML =
            '<label for="voluntario-cidade">Cidade</label>' +
            '<input type="text" name="cidade" id="voluntario-cidade" class="campo" placeholder="Digite sua cidade" required />';
        });
    });
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    // Validação usando o ParsleyJS para respeitar o data-parsley-mincheck dos checkboxes
    var parsleyInstance = $(form).parsley();
    if (!parsleyInstance.isValid()) {
      parsleyInstance.validate();
      return;
    }

    btnSubmit.disabled = true;
    var originalText = btnSubmit.innerHTML;
    btnSubmit.innerHTML = '<i class="fas fa-spinner fa-spin" style="margin-right: 8px;"></i> Enviando...';

    var formData = new FormData(form);

    fetch(url_base + "acoes/app/quero-ser-voluntario/envia_voluntario.php", {
      method: "POST",
      body: formData
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Erro na rede");
        return res.json();
      })
      .then(function (data) {
        btnSubmit.disabled = false;
        btnSubmit.innerHTML = originalText;

        if (data.status === "success") {
          if (typeof showAlert === "function") {
            showAlert("Sucesso!", data.message, "success");
          } else {
            alert(data.message);
          }

          form.reset();
          if (cidadeContainer) {
            cidadeContainer.innerHTML =
              '<label for="voluntario-cidade">Cidade</label>' +
              '<select name="cidade" id="voluntario-cidade" class="campo" required disabled>' +
              '<option value="">Selecione o Estado primeiro</option>' +
              '</select>' +
              '<span class="arrow"></span>';
          }
        } else {
          if (typeof showAlert === "function") {
            showAlert("Ops!", data.message, "error");
          } else {
            alert("Erro: " + data.message);
          }
        }
      })
      .catch(function (err) {
        console.error(err);
        btnSubmit.disabled = false;
        btnSubmit.innerHTML = originalText;
        if (typeof showAlert === "function") {
          showAlert("Erro", "Ocorreu um erro ao enviar o formulário. Tente novamente mais tarde.", "error");
        } else {
          alert("Ocorreu um erro ao enviar o formulário. Tente novamente mais tarde.");
        }
      });
  });
});
